module.exports = ".center{\n    text-align: center\n}\n.bold{\n    font-family: abb-bold\n}"